module.exports = __webpack_public_path__ + "img/tcdc-color.f9263772.png";